import CryptoJS from 'crypto-js';

export const encryptData = (data, salt) =>
    CryptoJS.AES.encrypt(JSON.stringify(data), salt).toString()


export const decryptData = (ciphertext, salt) => {
    const bytes = CryptoJS.AES.decrypt(ciphertext, salt);
    try {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    catch (err) {
        return null;
    }
}


export function GetCurrentSelectedActivity() {
    const activity = localStorage.getItem('curentSelectedActivity');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivity(activity) {
    localStorage.setItem('curentSelectedActivity', JSON.stringify(activity))
}


export function GetCurrentActivitiesData() {
    const activitiesData = localStorage.getItem('activitiesData');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetCurrentActivitiesData(activitiesData) {
    localStorage.setItem('activitiesData', JSON.stringify(activitiesData));
}


export function GetChildActivities() {
    const activitiesData = localStorage.getItem('childrenactivity');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetChildActivities(activitiesData) {
    localStorage.setItem('childrenactivity', JSON.stringify(activitiesData));
}

export function GetCurrentSelectedActivityODR() {
    const activity = localStorage.getItem('curentSelectedActivityODR');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityODR(activity) {
    localStorage.setItem('curentSelectedActivityODR', JSON.stringify(activity))
}




export function GetODRChildActivities() {
    const activitiesData = localStorage.getItem('ODRChildren');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetODRChildActivities(activitiesData) {
    localStorage.setItem('ODRChildren', JSON.stringify(activitiesData));
}




export function GetODRActivityStatements() {
    const activitiesData = localStorage.getItem('ODRActivityStatememts');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetODRActivityStatements(activitiesData) {
    localStorage.setItem('ODRActivityStatememts', JSON.stringify(activitiesData));
}




export function GetCurrentSelectedActivityMonthResp() {
    const activity = localStorage.getItem('curentSelectedActivityMR');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityMonthResp(activity) {
    localStorage.setItem('curentSelectedActivityMR', JSON.stringify(activity))
}


export function GetMRChildActivities() {
    const activitiesData = localStorage.getItem('MRChildren');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetMRChildActivities(activitiesData) {
    localStorage.setItem('MRChildren', JSON.stringify(activitiesData));
}




export function GetMRActivityStatements() {
    const activitiesData = localStorage.getItem('MRActivityStatememts');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetMRActivityStatements(activitiesData) {
    localStorage.setItem('MRActivityStatememts', JSON.stringify(activitiesData));
}



export function GetCurrentActivitiesDataODRInceleme() {
    const activitiesData = localStorage.getItem('activitiesDataIncelemeODR');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetCurrentActivitiesDataODRInceleme(activitiesData) {
    localStorage.setItem('activitiesDataIncelemeODR', JSON.stringify(activitiesData));
}


export function GetCurrentSelectedActivityODRInceleme() {
    const activitiesData = localStorage.getItem('selectedactivitiesDataIncelemeODR');
    const resp = activitiesData != null ? JSON.parse(JSON.stringify(activitiesData.toString().trim())) : activitiesData;
    return resp;
}

export function SetCurrentSelectedActivityODRInceleme(activitiesData) {
    localStorage.setItem('selectedactivitiesDataIncelemeODR', JSON.stringify(activitiesData));
}


export function GetCurrentSelectedActivityEvaluaterReport() {
    const activity = localStorage.getItem('curentSelectedActivityEvaluatorReport');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityEvaluaterReport(activity) {
    localStorage.setItem('curentSelectedActivityEvaluatorReport', JSON.stringify(activity))
}


export function GetCurrentSelectedActivityTRInceleme() {
    const activity = localStorage.getItem('curentSelectedActivityTRInceleme');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityTRInceleme(activity) {
    localStorage.setItem('curentSelectedActivityTRInceleme', JSON.stringify(activity))
}


export function GetCurrentSelectedActivityEvaluator() {
    const activity = localStorage.getItem('curentSelectedActivityEvaluator');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityEvaluator(activity) {
    localStorage.setItem('curentSelectedActivityEvaluator', JSON.stringify(activity))
}


export function GetCurrentSelectedActivityConsistency() {
    const activity = localStorage.getItem('curentSelectedActivityConsistency');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityConsistency(activity) {
    localStorage.setItem('curentSelectedActivityConsistency', JSON.stringify(activity))
}


export function GetCurrentSelectedActivityEditor() {
    const activity = localStorage.getItem('curentSelectedActivityEditor');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivityEditor(activity) {
    localStorage.setItem('curentSelectedActivityEditor', JSON.stringify(activity))
}

export function GetCurrentSelectedActivitySpellingControl() {
    const activity = localStorage.getItem('curentSelectedActivitySpellingControl');
    const resp = activity != null ? JSON.parse(JSON.stringify(activity.toString().trim())) : activity;
    return resp;
}

export function SetCurrentSelectedActivitySpellingControl(activity) {
    localStorage.setItem('curentSelectedActivitySpellingControl', JSON.stringify(activity))
}